/**
 * @param {import('./types').NotificationType} type
 * @return {string}
 */
export const getDefaultMessage = (type = 'warning') => {
  switch (type) {
    case 'error':
      return 'An error occurred';
    case 'success':
      return 'Success';
    case 'warning':
      return 'Warning';
    case 'info':
      return 'Information';
    default:
      return '';
  }
};
